import React from "react";
import PropTypes from "prop-types";
import { Drawer } from "@mui/material";
import { styled } from "@mui/system";
import "./style.scss";

const AnimatedDrawer = styled(Drawer)(({ theme }) => ({
    transition: theme.transitions.create(["transform", "opacity"], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeOut,
    }),
}));

const CustomDrawer = ({ open, onClose, children }) => {
    return (
        <AnimatedDrawer
            anchor="right"
            open={open}
            onClose={onClose}
            sx={{ zIndex: (theme) => theme.zIndex.modal + 1, p: "36px" }}
        >
            {children}
        </AnimatedDrawer>
    );
};

CustomDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default CustomDrawer;
